export default __webpack_public_path__ + "static/media/june2023-3.c010ecf5.jpg";